// Mirrors the backend capture validation (docs/plans/
// deposit-stripe-hold-runtime-spec.md §4): a positive amount with at most
// two decimal places, capped at the authorized deposit amount.
const CAPTURE_AMOUNT_RE = /^\d+(\.\d{1,2})?$/;

/**
 * Validates the raw capture-amount input of the deposit capture form:
 * 0 < amount <= max, at most two decimal places, dot as decimal separator.
 * The DOM-dependent badInput guard (Firefox reporting non-numeric input as
 * an empty value) stays in the consuming modal.
 */
export const isValidCaptureAmount = (value: string, max: number): boolean => {
    const trimmed = value.trim();
    if (!CAPTURE_AMOUNT_RE.test(trimmed)) return false;
    const amount = Number(trimmed);
    return amount > 0 && amount <= max;
};
